import request from '@/utils/request_cn';

export function getVendorList(data) {
  return request({
    url: `/sc-basic-merchant-backend/crm/vendor/list`,
    method: "post",
    data,
  });
}

export function getVendorDetail(params) {
  return request({
    url: `/sc-basic-merchant-backend/crm/vendor/getVendorDetailById`,
    params,
  });
}

export function getVendorPayment(params) {
  return request({
    url: `/sc-basic-merchant-backend/crm/payment`,
    params,
  });
}

export function getVendorPriceInfo(params) {
  return request({
    url: `/sc-basic-merchant-backend/crm/price/info`,
    params,
  });
}

export function getVendorInvoice(params) {
  return request({
    url: `/sc-basic-merchant-backend/crm/invoice`,
    params,
  });
}

export function getVendorReceivePayment(params) {
  return request({
    url: `/sc-basic-merchant-backend/crm/receive/payment`,
    params,
  });
}

export function getVendorContactsList(params) {
  return request({
    url: `/sc-basic-merchant-backend/crm/contacts/getVendorContactsList`,
    params,
  });
}

export function getVendorOfflineStoreList(params) {
  return request({
    url: `/sc-basic-merchant-backend/crm/channel/offlineStore/list`,
    params,
  });
}

export function getVendorChannelList(params) {
  return request({
    url: `/sc-basic-merchant-backend/crm/channel/sale/list`,
    params,
  });
}

export function getVendorExtInfo(params) {
  return request({
    url: `/sc-basic-merchant-backend/crm/vendor/ext/info`,
    params,
  });
}

export function getStockLocationByVendorId(params) {
  return request({
    url: `/sc-basic-merchant-backend/crm/stockLocation/getStockLocationByVendorId`,
    params,
  });
}

export function getDictList(params) {
  return request({
    url: `/sc-basic-merchant-backend/dict/list`,
    params,
  });
}

export function saveCRMAudit(data) {
  return request({
    url: `/sc-basic-merchant-backend/crm/audit/save`,
    method: 'post',
    data,
  });
}

export function saveSnapshot(data) {
  return request({
    url: `/sc-basic-merchant-backend/crm/editSnapshot/save`,
    method: 'post',
    data,
  });
}

export function getVendorAuditDetail(params) {
  return request({
    url: `/sc-basic-merchant-backend/crm/audit/get/before/info`,
    params,
  });
}

export function getGroupListByName(data) {
  return request({
    url: `/sc-basic-merchant-backend/crm/group/getGroupListByName`,
    data,
    method: 'post'
  });
}

export function getVendorByGroupId(params) {
  return request({
    url: `/sc-basic-merchant-backend/crm/vendor/getVendorByGroupId`,
    params,
  });
}

export function getVendorAuditShowDetail(params) {
  return request({
    url: `/sc-basic-merchant-backend/crm/audit/get`,
    params,
  });
}

export function approvalAudit(data) {
  return request({
    url: `/sc-basic-merchant-backend/crm/audit/approval`,
    method: 'post',
    data,
  });
}

export function getPerformanceByVendorId(params) {
  return request({
    url: `/sc-basic-merchant-backend/crm/performance/getPerformanceByVendorId`,
    params,
  });
}

export function getPerformanceMonthByVendorId(params) {
  return request({
    url: `/sc-basic-merchant-backend/crm/performance/getPerformanceMonthByVendorId`,
    params,
  });
}

export function queryEmailConfiguration(params) {
  return request({
    url: `/sc-basic-merchant-backend/crm/common/queryEmailConfiguration`,
    params,
  });
}
export function getVendorListByUserId(params) {
  return request({
    url: `/sc-basic-merchant-backend/crm/vendor/getVendorListByUserId`,
    params,
  });
}

export function getCRMVendorList() {
  return request({
    url: `/sc-basic-merchant-backend/crm/vendor/nameBox`,
    method: 'post',
  });
}

export function getComboVendorList(needChildVendorFlag) {
  return request({
    url: `/sc-merchant-common/v2/vendor/list/nameBox/excludeSeller/regionFilter`,
    method: 'post',
    data: {
      needChildVendorFlag,
    },
  });
}

export function getEmailContentType(params) {
  return request({
    url: `/sc-basic-merchant-backend/crm/common/getEmailContentType`,
    params,
  });
}
export function getActivityListBy(params) {
  return request({
    url: `/sc-basic-merchant-backend/crm/activity/getActivityListBy`,
    params,
  });
}

export function createVendor(data) {
  return request({
    url: `/sc-basic-merchant-backend/crm/prepare/createVendor`,
    method: 'post',
    data,
  });
}

export function updateVendorStatus(data) {
  return request({
    url: `/sc-basic-merchant-backend/crm/prepare/updateVendorStatus`,
    method: 'post',
    data,
  });
}

export function getCreatingVendorList(data) {
  return request({
    url: `/sc-basic-merchant-backend/crm/prepare/getCreatingVendorList`,
    method: 'post',
    data,
  });
}

//获取所有系统枚举
export async function getSystemList() {
  return (await request({
    url: `/basic-backend/boutique/system/list`,
    method: "get",
  })).data;
}

//区域一级列表
export async function vendorAreaListLevelOne() {
  return (await request({
    url: `/basic-backend/spu/split/config/groups?channelId=1`,
    method: 'get'
  })).data;
}

//获取所有国家列表
export async function getCountryList() {
  return (await request({
    url: `/basic-backend/address/country/list`,
    method: "get",
  })).data
}

//货币单位枚举
export async function getUnitList() {
  return (await request({
    url: `/basic-backend/price/unit/list`,
    method: "get",
  })).data
}

//获取公共枚举值
export async function getDictEnumList(params) {
  return (await request({
    url: `/sc-basic-merchant-backend/dict/list`,
    params,
  })).data
}


//新增店铺保存
export function prepareItConfiguration(data) {
  return request({
    url: `/sc-basic-merchant-backend/crm/prepare/itConfiguration`,
    data,
    method: 'post'
  });
}

//已创建店铺编辑更新
export function updateItConfiguration(data) {
  return request({
    url: `/sc-basic-merchant-backend/crm/prepare/updateItConfiguration`,
    data,
    method: 'post'
  });
}

//获取待处理状态
export async function getConfigChange(params) {
  return (await request({
    url: `/sc-basic-merchant-backend/crm/audit/list/config/change`,
    params,
  })).data;
}

//处理完成
export function vendorConfigfinished(params) {
  return request({
    url: `/sc-basic-merchant-backend/crm/vendor/config/finished`,
    params,
  });
}


//获取已创建状态店铺详情
export async function getItConfigurationDetail(params) {
  return (await request({
    url: `/sc-basic-merchant-backend/crm/prepare/getItConfiguration`,
    params,
  })).data;
}

export function getApprovalVendorDetail(params) {
  return request({
    url: `/sc-basic-merchant-backend/crm/prepare/getApprovalVendorDetail`,
    params,
  });
}

export function approvalVendor(data) {
  return request({
    url: `/sc-basic-merchant-backend/crm/prepare/approvalVendor`,
    method: 'post',
    data,
  });
}

export function deleteVendor(params) {
  return request({
    url: `/sc-basic-merchant-backend/crm/prepare/delete`,
    params,
  });
}

export function getCreatingVendorNameList(params) {
  return request({
    url: `/sc-basic-merchant-backend/crm/prepare/getCreatingVendorNameList`,
    params,
  });
}
export function updateVendorAsPerfection(params) {
  return request({
    url: `/sc-basic-merchant-backend/crm/audit/updateVendorAsPerfection`,
    params,
  });
}

export function getImBusinessStatus(data) {
  return request({
    url: `/sc-basic-merchant-backend/crm/im/business`,
    method: 'post',
    data,
  });
}

export function getGmvGraph(data) {
  return request({
    url: `/sc-basic-merchant-backend/crm/im/gmv`,
    method: 'post',
    data,
  });
}

export function getTop10BrandList(data) {
  return request({
    url: `/sc-basic-merchant-backend/crm/im/brand`,
    method: 'post',
    data,
  });
}

export function saveConfig(data) {
  return request({
    url: `/sc-basic-merchant-backend/crm/vendor/config/save`,
    method: 'post',
    data,
  });
}

export function resetPwd(data) {
  return request({
    url: `/sc-basic-merchant-backend/crm/vendor/reset`,
    method: 'post',
    data,
  });
}

export function getConfigStatus(params) {
  return request({
    url: `/sc-basic-merchant-backend/crm/audit/list/config/change`,
    method: 'get',
    params,
  });
}


///crm/product/info/{vendorId}商家货品情况
export async function productInfo(vendorId) {
  return (await request({
    url: `/sc-basic-merchant-backend/crm/product/info/${vendorId}`,
    method: 'get',
  })).data;
}
///crm/product/goods/all/{vendorId}全部商品货品情况
export async function productGoodsAll(vendorId) {
  return (await request({
    url: `/sc-basic-merchant-backend/crm/product/goods/all/${vendorId}`,
    method: 'get',
  })).data;
}

///crm/product/goods/onsale/{vendorId}在售商品货品情况
export async function productGoodsOnsale(vendorId) {
  return (await request({
    url: `/sc-basic-merchant-backend/crm/product/goods/onsale/${vendorId}`,
    method: 'get',
  })).data;
}
///crm/product/push/new/{vendorId}推货售罄率
export async function productPushNew(vendorId) {
  return (await request({
    url: `/sc-basic-merchant-backend/crm/product/push/new/${vendorId}`,
    method: 'get',
  })).data;
}
///crm/product/old/value/{vendorId}存货售罄率
export async function productOldValue(vendorId) {
  return (await request({
    url: `/sc-basic-merchant-backend/crm/product/old/value/${vendorId}`,
    method: 'get',
  })).data;
}
export function getFengShenUrl() {
  return request({
    url: `/sc-basic-merchant-backend/crm/im/dashboard/url`,
  });
}

export function getLogisticsInfo(params) {
  return request({
    url: `/sc-basic-merchant-backend/crm/vendor/logistics/info`,
    params,
  });
}

export function getPortalToken(params) {
  return request({
    url: `/sc-basic-merchant-backend/crm/vendor/get/token`,
    params,
  });
}

export function addPortalUser(data) {
  return request({
    url: `/sc-basic-merchant-backend/crm/vendor/relation`,
    method: 'post',
    data,
  });
}

export function getAfterSaleDict() {
  return request({
    url: `/sc-basic-merchant-backend/sale/after/performance/list/dict`,
  });
}

export function getAfterSalePerformance(params) {
  return request({
    url: `/sc-basic-merchant-backend/sale/after/performance/get`,
    params,
  });
}

export function updateAfterSalePerformance(data) {
  return request({
    url: `/sc-basic-merchant-backend/sale/after/performance/update`,
    method: 'post',
    data,
  });
}

export function addBusinessVisit(data) {
  return request({
    url: `/sc-basic-merchant-backend/business/visit/add`,
    method: 'post',
    data,
  });
}

export function getBusinessVisit(params) {
  return request({
    url: `/sc-basic-merchant-backend/business/visit/list`,
    params,
  });
}

export function getLogRecordList(params) {
  return request({
    url: `/sc-basic-merchant-backend/log/record/list`,
    params,
  });
}

export function getVendorExtDict(data) {
  return request({
    url: `/sc-basic-merchant-backend/vendor/channel/ext/info/dict`,
    method: 'post',
    data,
  });
}

export function getVendorConfigureList(data) {
  return request({
    url: `/sc-basic-merchant-backend/vendor/channel/ext/info/list`,
    method: 'post',
    data,
  });
}

export function getVendorConfigureTimeValue(params) {
  return request({
    url: `/sc-basic-merchant-backend/vendor/channel/ext/info/init`,
    params,
  });
}

export function saveVendorConfigure(data) {
  return request({
    url: `/sc-basic-merchant-backend/vendor/channel/ext/info/save`,
    method: 'post',
    data,
  });
}

export function updateVendorConfigure(data) {
  return request({
    url: `/sc-basic-merchant-backend/vendor/channel/ext/info/update`,
    method: 'post',
    data,
  });
}

export function delVendorConfigure(id) {
  return request({
    url: `/sc-basic-merchant-backend/vendor/channel/ext/info/del/${id}`,
  });
}

export function exportVendorConfigureList(data) {
  return request({
    url: `/sc-basic-merchant-backend/vendor/channel/ext/info/export`,
    method: 'post',
    data,
  });
}

export function importVendorConfigureList(data) {
  return request({
    url: `/sc-basic-merchant-backend/vendor/channel/ext/info/file`,
    method: 'post',
    data,
  });
}

export function checkDestroy(params) {
  return request({
    url: `/sc-basic-merchant-backend/crm/seller/checkDestroy`,
    params,
  });
}

export function sellerDestroy(data) {
  return request({
    url: `/sc-basic-merchant-backend/crm/seller/destroy`,
    method: 'post',
    data,
  });
}

export function batchUpdateBDInfo(data) {
  return request({
    url: `/sc-basic-merchant-backend/crm/vendor/batchUpdate/bdInfo`,
    method: 'post',
    data,
  });
}

export function getBoutiqueConfigurationPage(data) {
  return request({
    url: `/sc-basic-merchant-backend/boutique/configuration/page`,
    method: 'post',
    data,
  });
}

export function saveBoutiqueConfiguration(data) {
  return request({
    url: `/sc-basic-merchant-backend/boutique/configuration/save`,
    method: 'post',
    data,
  });
}

export function updateBoutiqueConfigurationPage(data) {
  return request({
    url: `/sc-basic-merchant-backend/boutique/configuration/update`,
    method: 'post',
    data,
  });
}

export function getVendorListExcludeImPull(data) {
  return request({
    url: `/sc-merchant-common/v2/vendor/list/nameBox/excludeImPull`,
    method: 'post',
    data,
  });
}

export function getVendorConfigInfo(vendorId) {
  return request({
    url: `/sc-basic-merchant-backend/crm/vendor/getVendorConfigInfo?vendorId=${vendorId}`,
  });
}
export function fastBanSale(data) {
  return request({
    url: `/sc-basic-merchant-backend/crm/vendor/fast/ban/sale`,
    method: 'post',
    data,
  });
}

export function getVendorInfo(params) {
  return request({
    url: `/sc-basic-merchant-backend/crm/vendor/list/vendor/ext/info`,
    method: 'get',
    params,
  });
}

export function updateVendorInfo(data) {
  return request({
    url: `/sc-basic-merchant-backend/crm/vendor/vendor/ext/info/update`,
    method: 'post',
    data,
  });
}

//开通结算功能（后端按国家自动判定角色 40/43）
export function addVendorSettlement(params) {
  return request({
    url: `/sc-basic-merchant-backend/crm/vendor/settlement/add`,
    method: 'post',
    params,
  });
}

//关闭结算功能（同时移除角色 40 和 43，幂等）
export function removeVendorSettlement(params) {
  return request({
    url: `/sc-basic-merchant-backend/crm/vendor/settlement/remove`,
    method: 'post',
    params,
  });
}
